import styled from "styled-components";

const Main = styled.main`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 16px;
    flex: 1;
    background-color: #F2F2F2;

    h3{
        font-size: 24px;
        color: #126BA5;
    }

    p{
        font-size: 18px;
        color: #666666;
        margin: 1.5em 0;
    }

`

export default Main